import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';

const DetailDeleteButton = ({ dataTestId, disabled = false, label, onClick, ...other }) => (
  <>
    <Box sx={{ display: { lg: 'block', xs: 'none' } }}>
      <Button
        color="secondary"
        data-testid={dataTestId}
        disabled={disabled}
        onClick={onClick}
        startIcon={<DeleteIcon />}
        {...other}
      >
        {label}
      </Button>
    </Box>
    <Box sx={{ display: { lg: 'none', xs: 'block' } }}>
      <IconButton
        color="secondary"
        data-testid={dataTestId ? `${dataTestId}-icon` : undefined}
        disabled={disabled}
        onClick={onClick}
        {...other}
      >
        <DeleteIcon />
      </IconButton>
    </Box>
  </>
);

DetailDeleteButton.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DetailDeleteButton;
